var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextBiteBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_475",
    "data-name": "Group 475",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.239,
    height: 61.239,
    viewBox: "0 0 61.239 61.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    d: "M30.62 0h30.62v61.239H30.62A30.62 30.62 0 0 1 0 30.62 30.62 30.62 0 0 1 30.62 0z",
    style: {
      fill: "#1253fa"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(7.771 7.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(11.416 12.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-2",
    d: "M1268.029 570.945h16.6a2.2 2.2 0 1 1 0 4.4h-16.6a2.2 2.2 0 1 1 0-4.4z",
    transform: "translate(-1265.83 -562.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-2",
    d: "M1282.073 559.694a2.192 2.192 0 0 1 1.556.645l8.3 8.312a2.2 2.2 0 0 1 0 3.106l-8.3 8.312a2.2 2.2 0 0 1-3.112-3.106l6.75-6.759-6.75-6.759a2.2 2.2 0 0 1 1.556-3.751z",
    transform: "translate(-1269.499 -559.694)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-2",
    d: "M1273.329 588.756a22.952 22.952 0 1 1 22.952-22.952 22.978 22.978 0 0 1-22.952 22.952zm0-44.948a22 22 0 1 0 22 22 22.021 22.021 0 0 0-22-22z",
    transform: "translate(-1250.377 -542.852)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBiteBtn);
export default __webpack_public_path__ + "static/media/next-bite-btn.1b64a585.svg";
export { ForwardRef as ReactComponent };